import type { ComponentTheme } from '../types/component-theme';

import { BillingStateVariants } from './constants/billing-state';

export default {
    slots: {
        root:
            'mx-auto flex max-w-2xl flex-col items-center gap-5 rounded-2xl bg-(image:--surface-legacy-panel-bg) p-8 ' +
            'text-center backdrop-blur-xl shadow-(--surface-legacy-panel-shadow)',
        icon: 'flex h-16 w-16 items-center justify-center rounded-2xl',
        content: 'flex flex-col gap-2',
        title: 'font-secondary text-2xl font-semibold leading-tight text-slate-950',
        description: 'text-sm font-medium leading-6 text-slate-500'
    },
    variants: {
        variant: {
            [BillingStateVariants.Success]: {
                icon: 'bg-(image:--accent-gradient) text-white shadow-(--progress-glow-shadow-md)'
            },
            [BillingStateVariants.Canceled]: {
                icon:
                    'border border-white/70 bg-white/45 text-slate-700 ' +
                    'shadow-[0.25rem_0.25rem_0.75rem_rgba(163,177,198,0.28),-0.25rem_-0.25rem_0.75rem_rgba(255,255,255,0.85)]'
            }
        }
    }
} satisfies ComponentTheme;
